import React, {Component} from 'react';

export default class Teac extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
